import {
  ClickEventComponentNames,
  CustomEventNames,
  EventTypes,
  useCRMEventsContext,
} from 'state/crm-events';

export const useClickLogs = () => {
  const { logRBIEvent } = useCRMEventsContext();

  const logSimpleClickEvent = (text: string, component: ClickEventComponentNames) => {
    logRBIEvent({
      name: CustomEventNames.CLICK_EVENT,
      type: EventTypes.Navigation,
      attributes: { text, component },
    });
  };

  const logOrderNowClickEvent = () =>
    logSimpleClickEvent('Order Now Button', ClickEventComponentNames.RAPID_RESCUE_CARD);

  const logPickUpOrderClickEvent = () =>
    logSimpleClickEvent('Pick Up Order Button', ClickEventComponentNames.BUTTON);

  const logDeliveryOrderClickEvent = () =>
    logSimpleClickEvent('Delivery Order Button', ClickEventComponentNames.BUTTON);

  const logCateringOrderClickEvent = () =>
    logSimpleClickEvent('Catering Order Button', ClickEventComponentNames.BUTTON);

  const logChallengeClickEvent = () =>
    logSimpleClickEvent('Challenge Button', ClickEventComponentNames.NAV_BAR);

  const logCateringClickEvent = () =>
    logSimpleClickEvent('Catering Button', ClickEventComponentNames.NAV_BAR);

  const logFoundationClickEvent = () =>
    logSimpleClickEvent('Foundation Button', ClickEventComponentNames.NAV_BAR);

  const logAccountDropdownClickEvent = () =>
    logSimpleClickEvent('Account Dropdown', ClickEventComponentNames.NAV_BAR);

  const logRewardPointsClickEvent = () =>
    logSimpleClickEvent('Reward Points Button', ClickEventComponentNames.NAV_BAR);

  const logScanButtonClickEvent = () =>
    logSimpleClickEvent('Scan Button', ClickEventComponentNames.BUTTON);

  const logCareersCardClickEvent = () =>
    logSimpleClickEvent('Careers Card - Work With Us', ClickEventComponentNames.MARKETING_CARD);

  const logHookAndLadderCardClickEvent = () =>
    logSimpleClickEvent(
      'Hook and Ladder Card - Order Now',
      ClickEventComponentNames.MARKETING_CARD
    );

  const logCateringCardClickEvent = () =>
    logSimpleClickEvent(
      'Catering Card - Take Me To Catering',
      ClickEventComponentNames.MARKETING_CARD
    );

  const logLTOCardClickEvent = (name: string) =>
    logSimpleClickEvent(`LTO Card - ${name}`, ClickEventComponentNames.LTO_CARD);

  const logWelcomeCardClickEvent = (name: string) =>
    logSimpleClickEvent(`Welcome Card - ${name}`, ClickEventComponentNames.MARKETING_CARD);

  const logSimplyBannerCtaClickEvent = (bannerTitle: string) =>
    logSimpleClickEvent(`Banner CTA - ${bannerTitle}`, ClickEventComponentNames.SIMPLY_BANNER);

  return {
    logOrderNowClickEvent,
    logPickUpOrderClickEvent,
    logDeliveryOrderClickEvent,
    logCateringOrderClickEvent,
    logChallengeClickEvent,
    logCateringClickEvent,
    logFoundationClickEvent,
    logAccountDropdownClickEvent,
    logRewardPointsClickEvent,
    logScanButtonClickEvent,
    logCareersCardClickEvent,
    logHookAndLadderCardClickEvent,
    logCateringCardClickEvent,
    logLTOCardClickEvent,
    logWelcomeCardClickEvent,
    logSimplyBannerCtaClickEvent,
  };
};
